
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school-plan-help",
      function () {
        return require("private-next-pages/school-plan-help/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school-plan-help"])
      });
    }
  